import {Cookies} from '../utils/Cookies';
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [createPersistedState({   storage: window.sessionStorage,})],
  state: {
    totalCount: 0, //每页的文件数
    showCheckall: false, //是否展示勾选框
    result: [], //勾选的文件
    root_path: '/', //请求列表路径
    bread: [], //面包屑
    is_folder: true, //判断当前点击是否为folder
    breadList: [], //面包屑
    issave: false, //是否选择设备保存
    areaCode: '86',
    phoneNum: '',
    operateType: '',
    loginFlag: false, //登录状态
    kid: '',
    deviceId: '', //选择保存的设备id
    city_code: '86',
    city_name: '中国',
    userInfo: {}, //用户信息
    shareInfo:{}, //分享用户信息
    deviceName: '', //已选中的设备
    btn_flag: false, //底部按钮展示
    count: 60,
    codeDisable: false,
  
      file_list: [], //首页文件
    
    all_flag: false, //是否选择全部
    issaveactive: false, //控制保存设备按钮可否点击
   
    deviceLists: [],
    startIndex: 0,
    showAplayer: false, //是否展示音乐播放器
    musicList: {}, //音乐播放需要的数据
    pdfInfo: {}, //pdf数据
    mode: false, //切换国家码
    isApp: false,
    showLoading: false,
    loadingText: '加载中',
   
    sortType: 1, //排序
    sort_state: 1,
    sortProp: "mtime",
    sortFlag: 'descending',
    errorVersion: '2.2',
    errorData:{},
    version: '0', //判断新旧固件，是否展示排序功能
    Api_Version:'v1' //判断当前的api接口是否是最新

  },
  getters: {
    errorData(state) {
      return state.errorData;
    },
    errorVersion(state) {
      return state.errorVersion;
    },
    // 获取当前sharekey的登录状态
    getLoginFlag:(state)=>(key)=>{
      return state.loginFlag[key]
    }
  },
  mutations: {
    setVersion(state, data) {
      state.version = data;
    },
    setErrorData(state, data) {
      state.errorData = data;
    },
    setErrorVersion(state, data) {
      state.errorVersion = data;
    },
    setSortFlag(state, val) {
      state.sortFlag = val;
    },
    setSortProp(state, val) {
      state.sortProp = val;
    },
    setShareInfo(state, val) {
      state.shareInfo = val;
    },
    setApi_Version(state, val) {
      
      state.Api_Version = val;
    },
   
    setShowLoading(state, val) {
      state.showLoading = val;
    },
    setLoadingText(state, val) {
      state.loadingText = val;
    },
    setShareKey(state, code) {
      state.shareKey = code;
    },
    setAreaCode(state, code) {
      state.areaCode = code;
    },
    setPhoneNum(state, num) {
      state.phoneNum = num;
    },
    setOperateType(state, type) {
      state.operateType = type;
    },
    // 设置当前sharekey的登录状态
    setLoginFlag(state, flag) {
      for(let i in  state.loginFlag){
   
        state.loginFlag[i]=false
      }
    
    state.loginFlag = {...state.loginFlag,[Cookies.get('shareKey')]:flag};
    },
    getTotalCount(state, payload) {
      state.totalCount = payload
    },
    getCheckStatus(state, payload) {
      state.showCheckall = payload
    },
    getRootPath(state, payload) {
   
      state.root_path = payload
    },
    setresult(state, path) {
    state.result=path
    
    },
    getBreadList(state, payload) {
     
      state.breadList = payload
    },
    getFolder(state, payload) {
      state.is_folder = payload
    },
    getSaveStatus(state, payload) {
      state.issave = payload
    },
    
    getKid(state, payload) {
      state.kid = payload
    },
    getDeviceId(state, payload) {
      state.deviceId = payload
    },
    getCityCode(state, payload) {
      state.city_code = payload
    },
    getCityName(state, payload) {
      state.city_name = payload
    },
    getUserInfo(state, payload) {
      state.userInfo = payload
    },
    getDeviceName(state, payload) {
      state.deviceName = payload
    },
    getBtnFlag(state, payload) {
      state.btn_flag = payload
    },
    getCount(state, payload) {
      state.count = payload
    },
    getCodeDisable(state, payload) {
      state.codeDisable = payload
    },
    getfileData(state, payload) {
      state.file_list = payload
    },
    chooseAll(state, payload) {
      state.all_flag = payload
    },
    getIssaveactive(state, payload) {
      state.issaveactive = payload
    },
  
    getDeviceLists(state, payload) {
      state.deviceLists = payload
    },
    getStartIndex(state, payload) {
      state.startIndex = payload
    },
    getAplayerStatus(state, payload) {
      state.showAplayer = payload
    },
    getMusicList(state, payload) {
      state.musicList = payload
    },
    getPdfInfo(state, payload) {
      state.pdfInfo = payload
    },
    getMode(state, payload) {
      state.mode = payload
    },
    getAllThumbnail(state, payload) {
      state.allThumbnail = payload
    },
    
    setAppState(state, payload) {
      state.isApp = payload
    },
    setSortType(state, param) {
			state.sortType = param;
		},
    setSortState(state, param) {
			state.sort_state = param;
		},


  }
})

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js